import { useEffect, useState } from "react";
import {
  Grid,
  Box,
  TextField,
  Button,
  FormControl,
  CircularProgress,
  Slider,
  Typography,
  InputAdornment,
} from "@mui/material";

import SelectableSearch from "../../../Base/views/SelectableSearch";
import { grey } from "@mui/material/colors";
import { useDispatch, useSelector } from "react-redux";
import CommonDatePicker from "../../../Base/views/CommonDatePicker";
import { GetMyGoalHelper } from "../../helpers/ManageGoalHelper";
import { UpdatePerformanceLogAction, AddPerformanceLogAction} from "../../../../../store/Employee/PMSystem/Action";

export default function LogCheckIn({
  currentPerformanceLog,
  closeMode,
  setOpenPopup,
  mode,
}) {
  const dispatch = useDispatch();
  const isPreview = mode === "Preview";
  const today = new Date();
  const initialValues = {
    checkin_type: "", 
    checkin_title: "",
    checkin_start_date: `${today.getFullYear() +"-" + ("0" + (today.getMonth() + 1)).slice(-2) + "-" + ("0" + today.getDate()).slice(-2)}`,
    checkin_end_date: `${today.getFullYear() +"-" + ("0" + (today.getMonth() + 1)).slice(-2) + "-" + ("0" + today.getDate()).slice(-2)}`,
    goal_sub_category_configuration_pk: null, 
    checkin_progress: 0, // 0 - 100
    checkin_comments: "",
  };
  const { minDojYear } = useSelector(
    (state) => state?.AncillaryReducer?.WorkSpaceDojReducer
  );
  const [form, setForm] = useState(initialValues);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  // fetch goals from store (assuming ManageGoalReducer holds goals)

  const [goalOption, setGoalopton] = useState({ load: true, values: [] });

  const CheckinTypes = {
    load: false,
    values: [
      { value: "Weekly", label: "Weekly" },
      { value: "Monthly", label: "Monthly" },
      { value: "Quarterly", label: "Quarterly" },
    ],
  };



  const validate = (fieldValues = form) => {
    let temp = { ...errors };

    if ("checkin_type" in fieldValues)
      temp.checkin_type = fieldValues.checkin_type
        ? ""
        : "Checkin Type is required";

    if ("checkin_title" in fieldValues)
      temp.checkin_title = fieldValues.checkin_title ? "" : "Title is required";

    if ("goal_sub_category_configuration_pk" in fieldValues)
      temp.goal_sub_category_configuration_pk = fieldValues.goal_sub_category_configuration_pk
        ? ""
        : "Select a related goal";

    if ("checkin_start_date" in fieldValues)
      temp.checkin_start_date = fieldValues.checkin_start_date
        ? ""
        : "Start Date is required";
    if ("checkin_end_date" in fieldValues)
      temp.checkin_end_date = fieldValues.checkin_end_date
        ? ""
        : "End Date is required";

    if ("checkin_progress" in fieldValues) {
      const val = fieldValues.checkin_progress;
      temp.checkin_progress =
        val === "" || val === null || isNaN(val) ? "Progress is required" : "";
    }

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const handleInputChange = (event, value) => {
    if (["goal_sub_category_configuration_pk", "checkin_type", "checkin_progress"].includes(event)) {
      if (value) {
        setForm({ ...form, [event]: value });
      } else {
        setForm({ ...form, [event]: "" });
      }
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ ...form, [event]: value ? value : "" });
    } else {
      setForm({
        ...form,
        [event.target.name]: event.target.value,
      });
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ ...form, [event.target.name]: event.target.value });
    }
  };


  const handleCancel = () => {
    setOpenPopup(false);
    closeMode();
    setForm(initialValues);
    setErrors({});
  };

  const handlesubmit = () => {
    if (!validate(form)) return;
    setLoading(true);
    if (currentPerformanceLog?.checkin_pk) {
      dispatch(
        UpdatePerformanceLogAction(
          form,
          (error, result) => {
            setLoading(false);
            if (!error && result?.data?.statuscode === 200) {
              setOpenPopup(false);
              setForm(initialValues);
            }
          }
        )
      );
    } else {
      dispatch(
        AddPerformanceLogAction(form, (error, result) => {
          setLoading(false);
          if (!error && result?.data?.statuscode === 200) {
            setOpenPopup(false);
            setForm(initialValues);
          }
        })
      );
    }
  };
    const handleGoalOption = () => {
      GetMyGoalHelper().then((res) => {
        if(res?.data?.statuscode === 200){
            setGoalopton({ load: false, values: res?.data?.data || [] });
        } else {
            setGoalopton({ load: false, values: [] });
        }
    })
    };
  useEffect(() => {
    if(currentPerformanceLog?.checkin_pk){
      setForm({
        ...currentPerformanceLog,
        goal_sub_category_configuration_pk: {
                    goal_sub_category_configuration_pk: currentPerformanceLog?.goal_sub_category_configuration_pk, 
                    goal_sub_category_name: currentPerformanceLog?.goal_sub_category_name 
                  },
        checkin_type: {
          value: currentPerformanceLog?.checkin_type,
          label: currentPerformanceLog?.checkin_type,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[currentPerformanceLog])

  return (
    <Box>
      <Grid container spacing={2}>
        {/* Related Goal */}
        <Grid item xs={12} sx={{ px: "0.75rem", py: "0.25rem" }}>
          <FormControl fullWidth>
            <SelectableSearch
              disabled={isPreview}
              label="Related Goal"
              value={form?.goal_sub_category_configuration_pk}
              loading={handleGoalOption}
              fieldLabel="goal_sub_category_name"
              name="goal_sub_category_configuration_pk"
              size="small"
              data={goalOption}
              onChangeEvent={handleInputChange}
              {...(errors.goal_sub_category_configuration_pk && {
                error: true,
                helperText: errors.goal_sub_category_configuration_pk,
              })}
            />
          </FormControl>
        </Grid>
        {/* Checkin Type */}
        <Grid item xs={12} sx={{ px: "0.75rem", py: "0.25rem" }}>
          <FormControl fullWidth>
            <SelectableSearch
              disabled={isPreview}
              label="Check-In Type"
              value={form?.checkin_type}
              fieldLabel="label"
              loading={() => {}}
              name="checkin_type"
              size="small"
              data={CheckinTypes}
              onChangeEvent={(name, val) =>
                handleInputChange("checkin_type", val)
              }
              {...(errors.checkin_type && {
                error: true,
                helperText: errors.checkin_type,
              })}
            />
          </FormControl>
        </Grid>

        {/* Checkin Title */}
        <Grid item xs={12} sx={{ px: "0.75rem", py: "0.25rem" }}>
          <FormControl fullWidth>
            <TextField
              disabled={isPreview}
              id="checkin-title"
              label="Check-In Title"
              value={form.checkin_title}
              name="checkin_title"
              variant="outlined"
              size="small"
              required
              onChange={handleInputChange}
              {...(errors.checkin_title && {
                error: true,
                helperText: errors.checkin_title,
              })}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={12} sx={{ px: "0.75rem", py: "0.25rem" }}>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ mb: 1, ml: 1, fontWeight: 600 }}
          >
            Date period in which this task was completed
          </Typography>

          <Grid container spacing={2}>
            {/* Start Date */}
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <CommonDatePicker
                  required
                  disabled={isPreview}
                  name="checkin_start_date"
                  label="Start Date"
                  size="small"
                  pickerType="date"
                  DefaultDTvalue={form?.checkin_start_date}
                  maxDate={new Date(new Date().setFullYear(new Date().getFullYear() + 1))}
                  minDate={new Date(new Date(minDojYear).getFullYear() - 1, new Date(minDojYear).getMonth(), 1)} 
                  pickerFormat="dd/MM/yyyy"
                  handleChange={(value) =>
                    handleInputChange({
                      target: {
                        name: "checkin_start_date",
                        value: value
                          ? `${value?.getFullYear()}-${(
                              "0" +
                              (value.getMonth() + 1)
                            ).slice(-2)}-${("0" + value.getDate()).slice(-2)}`
                          : "",
                      },
                    })
                  }
                  {...(errors?.checkin_start_date && {
                    error: true,
                    helperText: errors?.checkin_start_date,
                  })}
                />
              </FormControl>
            </Grid>

            {/* End Date */}
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <CommonDatePicker
                  required
                  disabled={isPreview}
                  name="checkin_end_date"
                  label="End Date"
                  size="small"
                  pickerType="date"
                  DefaultDTvalue={form?.checkin_end_date}
                  minDate={new Date(form?.checkin_start_date)}
                  maxDate={new Date(new Date().setFullYear(new Date().getFullYear() + 1))} 
                  pickerFormat="dd/MM/yyyy"
                  handleChange={(value) =>
                    handleInputChange({
                      target: {
                        name: "checkin_end_date",
                        value: value
                          ? `${value?.getFullYear()}-${(
                              "0" +
                              (value.getMonth() + 1)
                            ).slice(-2)}-${("0" + value.getDate()).slice(-2)}`
                          : "",
                      },
                    })
                  }
                  {...(errors?.checkin_end_date && {
                    error: true,
                    helperText: errors?.checkin_end_date,
                  })}
                />
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={4} sx={{ px: "0.75rem", py: "0.25rem" }}>
          <FormControl fullWidth>
            <TextField
              disabled={isPreview}
              label="Progress (%)"
              type="number"
              size="small"
              inputProps={{ min: 0, max: 100 }}
              value={form.checkin_progress}
              onChange={(e) =>
                handleInputChange({
                  target: {
                    name: "checkin_progress",
                    value: Math.max(
                      0,
                      Math.min(100, Number(e.target.value) || 0)
                    ),
                  },
                })
              }
              InputProps={{
                endAdornment: <InputAdornment position="end">%</InputAdornment>,
              }}
              {...(errors.checkin_progress && {
                error: true,
                helperText: errors.checkin_progress,
              })}
            />
          </FormControl>
        </Grid>
        {/* Progress Slider + Numeric */}
        <Grid item xs={12} md={8} sx={{ px: "0.75rem", py: "0.25rem" }}>
          <Box pl={"10px"} pr={"18px"}>
            <Slider
              disabled={isPreview}
              value={
                typeof form.checkin_progress === "number"
                  ? form.checkin_progress
                  : 0
              }
              name="progress-slider"
              onChange={(e, val) => handleInputChange("checkin_progress", val)}
              aria-labelledby="progress-slider"
              step={1}
              marks={[0, 25, 50, 75, 100].map((v) => ({ value: v, label: `${v}%` }))}
              min={0}
              max={100}
            />
          </Box>
        </Grid>

        {/* Progress Notes */}
        <Grid item xs={12} sx={{ px: "0.75rem", py: "0.25rem", mt:"-12px" }}>
          <FormControl fullWidth>
            <TextField
              disabled={isPreview}
              multiline
              rows={4}
              name="checkin_comments"
              value={form.checkin_comments}
              onChange={handleInputChange}
              label="Progress Note / Comment"
              placeholder="Write progress, blockers, next steps..."
            />
          </FormControl>
        </Grid>
      </Grid>

      {/* Actions */}
      <Grid
        container
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 2,
          px: "0.75rem",
          py: "1rem",
        }}
      >
        <Button
          onClick={handleCancel}
          sx={{ ":hover": { color: grey[50] } }}
          variant="outlined"
          className="mpl-secondary-btn"
        >
          {isPreview ? "Close" : "Cancel"}
        </Button>

        {!isPreview && (
          <Button
            onClick={handlesubmit}
            variant="contained"
            color="primary"
            type="submit"
            className="mpl-primary-btn"
            disabled={loading}
            startIcon={
              loading ? <CircularProgress size={18} color="inherit" /> : null
            }
          >
            {currentPerformanceLog ? "Update" : "Save"}
          </Button>
        )}
      </Grid>
    </Box>
  );
}
